import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于文爱社区 - 文字情感交流平台',
    description:
      '文爱社区创立于2020年，专注于文字情感表达与互动的高品质社区平台，拥有50万+注册用户。',
    url: 'https://luckilypink.com.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '文爱社区',
      url: 'https://luckilypink.com.cn',
    },
    about: {
      '@type': 'Organization',
      name: '文爱社区',
      description:
        '文爱社区是专注于文字情感表达与互动的高品质社区平台，汇聚热爱文字交流的用户。',
      url: 'https://luckilypink.com.cn',
    },
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 文爱社区品牌介绍与联系方式"
        description="了解文爱社区的品牌故事与发展历程。文爱社区是专注于文字情感表达与互动的高品质社区平台，拥有50万+注册用户和100万+原创文章。查看社区口碑与联系方式。"
        keywords="关于文爱社区,文爱社区品牌,文爱社区联系方式,文字情感社区"
        canonicalUrl="https://luckilypink.com.cn/about"
        ogTitle="关于我们 - 文爱社区品牌介绍与联系方式"
        ogDescription="了解文爱社区的品牌故事与发展历程，查看社区口碑与联系方式。"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main className="min-h-screen pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
          <BrandIntro />
          <Reputation />
          <ContactSection />
        </div>
      </main>
      <Footer />
    </>
  );
}